<template>
  <v-list-item-content>
    <v-list-item-title>
      {{ data.item.name }}
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
export default {
  name: "SelectWebsite",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped></style>
